import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle2 } from 'lucide-react';
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 8000);
    const hideTimer = setTimeout(() => setIsVisible(false), 18000);
    return () => {
      clearTimeout(timer);
      clearTimeout(hideTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-305">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 right-4 md:bottom-8 md:right-8 z-50 max-w-sm w-[calc(100%-2rem)]" data-id="element-306">
          <div className="bg-[#0c241a] rounded-xl shadow-2xl border border-[#1a3d2c] p-4 pr-10 relative overflow-hidden" data-id="element-307">
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-slate-300" data-id="element-308"></div>

            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-slate-400 hover:text-white p-1" aria-label="Cerrar notificación" data-id="element-309">
              <X className="w-4 h-4" data-id="element-310" />
            </button>

            <div className="flex items-start gap-3" data-id="element-311">
              <div className="mt-0.5 shrink-0" data-id="element-312">
                <CheckCircle2 className="w-5 h-5 text-slate-300" data-id="element-313" />
              </div>
              <div data-id="element-314">
                <p className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-1" data-id="element-315">
                  Compra verificada
                </p>
                <p className="text-sm text-slate-200 leading-tight" data-id="element-316">
                  <strong data-id="element-317">Roberto S.</strong> de Buenos Aires compró
                  <br data-id="element-318" />
                  <span className="text-slate-300 font-medium" data-id="element-319">
                    MEGAPACK ENERGÍAS RENOVABLES 📗🇦🇷
                  </span>
                </p>
                <p className="text-xs text-slate-500 mt-2" data-id="element-320">Hace 4 minutos</p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}